export default "__VITE_ASSET__DT$AuBol__"